import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface PanelWrapperProps {
  title: string;
  subtitle?: string;
  contentClassName?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  /** 隐藏与上一个面板之间的分割线。 */
  hideDivider?: boolean;
}

/**
 * 通用工具参数分组容器，支持按业务面板控制相邻分割线。
 */
export default function PanelWrapper({
  title,
  subtitle,
  contentClassName,
  children,
  style,
  hideDivider = false,
}: PanelWrapperProps) {
  return (
    <div
      className={classNames(styles.panel_wrapper, {
        [styles.no_divider]: hideDivider,
      })}
      style={style}
    >
      <div className={styles.panel_wrapper_title}>{title}</div>
      {!!subtitle && <div className={styles.panel_wrapper_subtitle}>{subtitle}</div>}
      <div className={classNames(styles.panel_wrapper_content, contentClassName)}>
        {children}
      </div>
    </div>
  );
}
